/* utils.tsx generated by @compiled/babel-plugin v0.36.1 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { useIntl } from 'react-intl-next';
import { Date } from '@atlaskit/date';
import { timestampToString } from '@atlaskit/editor-common/utils';
var nodeRenderers = {
  date: function date(node, intl) {
    var displayString = timestampToString(node.attrs.timestamp, intl);
    return /*#__PURE__*/React.createElement(Date, {
      value: node.attrs.timestamp
    }, displayString);
  }
};
export var InlineNodeRenderer = function InlineNodeRenderer(_ref) {
  var node = _ref.node;
  var intl = useIntl();
  var render = nodeRenderers[node.type.name];
  return render ? render(node, intl) : /*#__PURE__*/React.createElement("span", null, node.type.name);
};